<template>
  <div>
    <el-row :gutter="20">
      <el-col :xs="{ span: 24 }" :sm="{ span: 6}">
        <el-select v-model="cladeType" size="small" style="width: 100%" @change="cladeTypeChange">
          <el-option label="Nextstrain Clade" value="nextstrain_clade"></el-option>
          <el-option label="Pangolin lineage" value="pangolin_lineage"></el-option>
        </el-select>
      </el-col>
      <el-col :xs="{ span: 24 }" :sm="{ span: 18 }">
          <el-select v-if="cladeType === 'pangolin_lineage'" id="pango-search-select" size="small" style="width: 100%;"
            v-model="pangolinLineages" multiple filterable remote reserve-keyword placeholder="Pango Lineage Search"
            :remote-method="pangoLineageSearch" :loading="searchLoading" @change="pangoLineageSelection" >
            <el-option v-for="item in pangoLineageSelectOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
      </el-col>

    </el-row>
    
    <el-row id="clade-area-plot" style="margin-top: 30px">
      <clade-moving-average-timeline-area :key="updateCladeFrequencyTimeline" 
        :plotdata="cladeFrequencyData" :cladeType="cladeType" height="40vh">
      </clade-moving-average-timeline-area>
    </el-row>

  </div>
</template>

<script>
import { store } from '@/scripts/store.js';
import PostService from '@/scripts/post_service.js'
require ('echarts/theme/infographic');

const _ = require('lodash')

export default {
  name: 'SitutationCladeTimeline',
  components: {
    CladeMovingAverageTimelineArea: () => import('@/components/plots/CladeMovingAverageTimelineArea.vue')
  },
  created() {
    
  },
  data() {
    const clades = _.filter(store.constants.clades, c => { return c !== 'Unassigned'})
    
    return { 
      store: store,
      cladeSelect: clades,
      cladeType: "nextstrain_clade",
      updateCladeFrequencyTimeline: 0,
      cladeFrequencyData: [],
      pangoLineageSelectOptions: [], // _.map(store.constants.pangolinLineages, d => { return { label: d, value: d } }),
      pangolinLineages: [],
      searchLoading: false,
      plotWidth: 0,
      requiredRows: 1,
      states: _.map(store.constants.states, s => { return { value: s.name, label: s.name } }),
      selectedStates: ['Gujarat', 'Maharashtra', 'Telangana', 'Delhi', 'Odisha', 'West Bengal', 'Karnataka', 'Uttarakhand', 'Haryana', 'Tamil Nadu'].reverse(),
      showOthers: true,
    } 
  },
  mounted() {
    const context = this
    context.cladeTypeChange('nextstrain_clade')
    context.pangolinLineages = _.map(_.sortBy(store.datasets.topPangolinLineages, 'total'), 'pangolin_lineage')
  },
  computed: {
  },
  methods: {
    pangoLineageSearch(query) {
      if (query !== '') {
        this.searchLoading = true;
        setTimeout(() => {
          this.searchLoading = false;
          this.pangoLineageSelectOptions = _.map(store.constants.pangolinLineages.filter(item => {
            return item.toLowerCase()
              .indexOf(query.toLowerCase()) > -1;
          }), d => { return { label: d, value: d } });
        }, 200);
      } else {
        this.pangoLineageSelectOptions = [];
      }
    },
    
    async cladeTypeChange(val) {
      const context = this
      if (val === 'nextstrain_clade') {
        context.cladeFrequencyData = await PostService.getPlotData('cladeFrequencyTimeline')
        context.updateCladeFrequencyTimeline += 1
      }
      else {
        const  query = 'pangolinFrequencyTimeline&lineage[]='+ context.pangolinLineages.join('&lineage[]=')
        context.cladeFrequencyData = await PostService.getPlotData(query)
        context.updateCladeFrequencyTimeline += 1
      }
    },

    async pangoLineageSelection(val) {
      const context = this
      const  query = 'pangolinFrequencyTimeline&lineage[]='+ val.join('&lineage[]=')
      context.cladeFrequencyData = await PostService.getPlotData(query)
      context.updateCladeFrequencyTimeline += 1
    }
  },
}
</script>

<style>

  .select-state .el-select__tags span .el-tag {
    color: #E54138 !important;
    background-color: white;
    border: 1px solid #ff9f9a;
    
  }

  .select-state .el-select__tags span .el-tag i {
    color: white;
    background-color: #E54138;
    border: none;
    margin-right: 5px;
  }
  .select-state.el-select-dropdown.is-multiple .el-select-dropdown__item.selected {
    color: #E54138;
  }
  .select-state.el-select .el-input.is-focus .el-input__inner {
    border-color: #E54138 !important;
  }

  .clade-checkbox.el-checkbox-button.is-focus .el-checkbox-button__inner{
    border-color: #E54138 !important;
  }
  .clade-checkbox.el-checkbox-button.is-focus .el-checkbox-button__inner:hover{
    color: #000000 !important;
  }
  .clade-checkbox.el-checkbox-button .el-checkbox-button__inner:hover{
    color: #000000 !important;
  }
</style>